<template>
  <div class="tabs">
    <div
      class="item"
      v-for="item in listData"
      :key="item.value"
      :class="{active: active === item.value}"
      @click="change(item)"
    >
      {{ item.label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: [String, Number],
      default: ""
    },
    listData: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    change(item){
      this.$emit("change", item);
    }
  }
}
</script>

<style scoped lang="less">
  .tabs{
    display: flex;
    background: #F9F9F9;
    .item{
      flex: 1;
      text-align: center;
      line-height: 70px;
      &.active{
        background: rgba(51, 153, 255, 1);
        color: #fff;
      }
    }
  }
</style>
